// src/pages/Inventario.js
import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IngredientesTable from '../components/inventory/IngredientesTable';
import ProductosTable from '../components/inventory/ProductosTable';
import BebidasTable from '../components/inventory/BebidasTable';
import '../styles/Inventario.css';

const VISTAS = [
  { id: 'ingredientes', etiqueta: 'Ingredientes' },
  { id: 'productos', etiqueta: 'Productos' },
  { id: 'bebidas', etiqueta: 'Bebidas' },
];

function InventarioPage({ userRole }) {
  const isReadOnly = userRole === 'Cajero' || userRole === 'Mesero' || userRole === 'Empleado';
  const [vista, setVista] = useState('ingredientes');

  return (
    <div className="inventario" data-densidad="compacta">
      <ToastContainer position="top-right" autoClose={2200} />

      <div className="encabezado-pagina">
        <div>
          <h1>Inventario</h1>
          <p className="subtitulo">
            {isReadOnly
              ? 'Consulta de existencias. Tu rol no permite editar.'
              : 'Existencias, recetas y precios.'}
          </p>
        </div>
      </div>

      <div className="pestanas" role="tablist" aria-label="Sección de inventario">
        {VISTAS.map((v) => (
          <button key={v.id} role="tab" aria-selected={vista === v.id}
            className={`pestana ${vista === v.id ? 'activa' : ''}`}
            onClick={() => setVista(v.id)}>
            {v.etiqueta}
          </button>
        ))}
      </div>

      <section className="tarjeta-base">
        {vista === 'ingredientes' && <IngredientesTable isReadOnly={isReadOnly} />}
        {vista === 'productos' && <ProductosTable isReadOnly={isReadOnly} />}
        {vista === 'bebidas' && <BebidasTable isReadOnly={isReadOnly} />}
      </section>
    </div>
  );
}

export default InventarioPage;
